import { render, staticRenderFns } from "./FinanceTabInvoices.vue?vue&type=template&id=5f904365&scoped=true"
import script from "./FinanceTabInvoices.vue?vue&type=script&lang=js"
export * from "./FinanceTabInvoices.vue?vue&type=script&lang=js"
import style0 from "./FinanceTabInvoices.vue?vue&type=style&index=0&id=5f904365&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f904365",
  null
  
)

export default component.exports